import { createContext, useContext, useState } from "react";

export const InvestorDetailContext = createContext({});

export const useInvestorDetails = () => useContext(InvestorDetailContext);

export const InvestorDetailProvider = ({ children }) => {
  const [investorDetails, setInvestorDetails] = useState(null);

  return <InvestorDetailContext.Provider value={{ investorDetails, setInvestorDetails }}>
    {children}
  </InvestorDetailContext.Provider>;
};